import type { User } from 'firebase/auth'
import type { Team } from '~shared/types'
import { atom } from 'jotai'

export const _userAtom = atom<User | null>(null)

export const userAtom = atom(
  (get) => get(_userAtom),
  (_, set, updatedUser: User | null) => {
    set(_userAtom, updatedUser)
  },
)

export const _userTeamAtom = atom<Team | null>(null)

export const userTeamAtom = atom(
  (get) => get(_userTeamAtom),
  (_, set, updatedTeam: Team | null) => {
    set(_userTeamAtom, updatedTeam)
  },
)

/**
 * @deprecated Use `useTeamsByUserId` from React Query instead.
 * This atom is kept for backwards compatibility during migration.
 */
export const _userTeamsAtom = atom<Team[] | null>(null)

/**
 * @deprecated Use `useTeamsByUserId` from React Query instead.
 * This atom is kept for backwards compatibility during migration.
 *
 * Consumers:
 * - `routes/dashboard/parent.jsx` - syncs from React Query
 * - `entities/team/api/hooks.ts` - useCreateTeam, useTeamsByUserId
 */
export const userTeamsAtom = atom(
  (get) => get(_userTeamsAtom),
  (_, set, teams: Team[] | null) => {
    set(_userTeamsAtom, teams)
  },
)
